import { render } from "./AlbumsView.vue?vue&type=template&id=17667323"
import script from "./AlbumsView.vue?vue&type=script&lang=js"
export * from "./AlbumsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__